<template>
  <img :src="`${config.publicPath}${icon}`" alt="icon" />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { configService } from "@/services/config-service";

@Options({
  props: {
    icon: String,
  },
})
export default class Icon extends Vue {
  config = configService;
}
</script>
